export const NEW_REQUEST_STEP = 'new_request' as const;
export const DISCOVERY_STEP = 'discovery' as const;
export const QUOTE_CREATION_STEP = 'quote_creation' as const;
export const CONSTRUCTION_STEP = 'construction' as const;
export const QUOTE_VALIDATED_STEP = 'quote_validated' as const;
export const POSTPONED_STEP = 'postponed' as const;
export const PAYMENT_CONFIRMED_STEP = 'payment_confirmed' as const;
export const TRIP_PREPARATION_STEP = 'trip_preparation' as const;
export const TRAVELLING_STEP = 'travelling' as const;
export const DEFERRED_TRIP_STEP = 'deferred_trip' as const;
export const TRIP_HAS_ENDED_STEP = 'trip_has_ended' as const;
export const CLOSED_STEP = 'closed' as const;
export const CANCELLED_STEP = 'cancelled' as const;
export const LOST_STEP = 'lost' as const;
